export default "__VITE_ASSET__D7h2MHXx__"